import { signalStoreFeature, type, withMethods } from '@ngrx/signals';

import { IImportItem } from '../../models';
import { ImportStatus, ImportStep, ImportStepStatus } from '../../enums';

const importStepsOrder = [
	ImportStep.None,
	ImportStep.UploadFile,
	ImportStep.Separator,
	ImportStep.ColumnPosition,
	ImportStep.MappingValue,
	ImportStep.ConsistencyCheck,
	ImportStep.PreImport,
	ImportStep.Imported,
];

export function withImportDetailSteps<_>() {
	return signalStoreFeature(
		{
			state: type<{
				importItem: IImportItem,
			}>(),
		},

		withMethods(store => {			
			const getStepStatus = (whichStep: ImportStep): ImportStepStatus => {
				if (store.importItem()) {
					return importStepsOrder.indexOf(store.importItem().currentStep) <= importStepsOrder.indexOf(whichStep) ?
						ImportStepStatus.ToBeDone : ImportStepStatus.Done;
				}
				return ImportStepStatus.ToBeDone;
			};
			
			const getStep1Status = (): ImportStepStatus => getStepStatus(ImportStep.UploadFile);
			const getStep2Status = (): ImportStepStatus => getStepStatus(ImportStep.Separator);
			const getStep3Status = (): ImportStepStatus => getStepStatus(ImportStep.ColumnPosition);
			const getStep35Status = (): ImportStepStatus => getStepStatus(ImportStep.MappingValue);
			const getStep4Status = (): ImportStepStatus => getStepStatus(ImportStep.PreImport);

			const getStep5Status = (): ImportStepStatus => {
				if (!store.importItem()) return ImportStepStatus.ToBeDone;
				if (store.importItem().status === ImportStatus.Error) return ImportStepStatus.Error;
				if (store.importItem().status === ImportStatus.Done) return ImportStepStatus.Done;

				return ImportStepStatus.ToBeDone;
			};
			
			const step2Disabled = () => getStep1Status() !== ImportStepStatus.Done;
			const step3Disabled = () => step2Disabled() || getStep2Status() !== ImportStepStatus.Done;
			const step35Disabled = () => step3Disabled() || getStep3Status() !== ImportStepStatus.Done;
			const step4Disabled = () => step35Disabled() || getStep35Status() !== ImportStepStatus.Done;
			const step5Disabled = () => step4Disabled() || getStep4Status() !== ImportStepStatus.Done;

			return {
				getStep1Status,
				getStep2Status,
				getStep3Status,
				getStep35Status,
				getStep4Status,
				getStep5Status,
				step2Disabled,
				step3Disabled,
				step35Disabled,
				step4Disabled,
				step5Disabled,
			}
		})
	)
}